module.exports = "<div class=\"footer_tagline clear\">\n  <h3 ng-bind-html=\"main.siteConst.footerTagline\"></h3>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/site_core/src/components/footerTagline/footerTagline.html
// module id = 176
// module chunks = 0